import React, { memo } from 'react';
import cn from 'classnames';

import SingleSelect, { SingleSelectProps } from 'components/SingleSelect';

import styles from './Dropdown.module.scss';

export interface DropdownProps extends SingleSelectProps {
  /*label*/
  label?: string;
  /** has primary background? */
  hasPrimaryBg?: boolean;
  /** triggerButtonClassName */
  triggerButtonClassName?: string;
  /** hide chevron icon on disabled */
  hideChevronIconOnDisabled?: boolean;
}

export const Dropdown: React.FC<DropdownProps> = memo(
  (props: DropdownProps) => {
    const {
      label = props.title,
      className,
      style,
      hasPrimaryBg,
      triggerButtonClassName,
    } = props;
    const contentClassNames = cn(
      {
        [styles.Dropdown]: true,
      },
      className
    );

    return (
      <div className={contentClassNames} style={style} data-testid="Dropdown">
        <div className={styles.DropdownLabel}>{label}</div>
        <SingleSelect
          {...props}
          className={styles.DropdownList}
          triggerButtonClassName={cn(
            styles.DropdownTriggerButton,
            {
              [styles.DropdownTriggerButtonPrimary]: hasPrimaryBg,
            },
            triggerButtonClassName
          )}
        />
      </div>
    );
  }
);

Dropdown.displayName = 'Dropdown';
